import React, { useCallback } from 'react';
import classNames             from 'classnames';
import * as PropTypes         from 'prop-types';

const CollapseBlock = function(props) {
  const {
          label,
          children,
          open = false,
          onToggle,
        } = props;

  const [isOpen, setIsOpen] = React.useState(open);

  const handleOpen = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    setIsOpen(!isOpen);
    if (onToggle) {
      onToggle(!isOpen);
    }
  }, [isOpen, onToggle]);

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div
      className={classNames(
        'collapse',
        { 'open': isOpen },
      )}
    >
      <h3
        className={'title'}
        onClick={handleOpen}
      >
        {label}
        <span className={'ic-arrow-top'} />
      </h3>
      <div className={'body'}>{children}</div>
    </div>
  );
};

CollapseBlock.propTypes = {
  open:     PropTypes.bool,
  label:    PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onToggle: PropTypes.func,
};

export default CollapseBlock;